"use client";

import { useState, useEffect, ReactNode } from "react";
import PasswordProtection from "../PasswordProtection/PasswordProtection";

interface PasswordWrapperProps {
  isProtected: boolean;
  pageId: number;
  children: ReactNode;
}

function readSessionAuth(pageId: number): boolean {
  if (typeof window === "undefined") return false;
  return sessionStorage.getItem(`wp_page_${pageId}_auth`) === "true";
}

export default function PasswordWrapper({
  isProtected,
  pageId,
  children,
}: PasswordWrapperProps) {
  // Match SSR on first paint (no sessionStorage). useEffect upgrades auth after hydrate
  // so we skip the old loading spinner without causing a hydration mismatch.
  const [isAuthenticated, setIsAuthenticated] = useState(!isProtected);

  useEffect(() => {
    if (!isProtected) {
      setIsAuthenticated(true);
      return;
    }
    setIsAuthenticated(readSessionAuth(pageId));
  }, [isProtected, pageId]);

  const handlePasswordSuccess = () => {
    setIsAuthenticated(true);
  };

  if (isProtected && !isAuthenticated) {
    return (
      <div className="container mx-auto px-4 py-8">
        <PasswordProtection
          pageId={pageId}
          onPasswordSuccess={handlePasswordSuccess}
          className="mt-8"
        />
      </div>
    );
  }

  return <>{children}</>;
}
